export class ThemeEvents {
  static variantSelected = "variant:selected";
  static variantUpdate = "variant:update";
  static cartUpdate = "cart:update";
  static cartError = "cart:error";
  static mediaStartedPlaying = "media:started-playing";
  static quantitySelectorUpdate = "quantity-selector:update";
  static megaMenuHover = "megaMenu:hover";
  static zoomMediaSelected = "zoom-media:selected";
  static discountUpdate = "discount:update";
  static FilterUpdate = "filter:update";
}
export class VariantSelectedEvent extends Event {
  constructor(e) {
    (super(ThemeEvents.variantSelected, { bubbles: !0 }),
      (this.detail = { resource: e }));
  }
}
export class VariantUpdateEvent extends Event {
  constructor(e, t, s) {
    (super(ThemeEvents.variantUpdate, { bubbles: !0 }),
      (this.detail = {
        resource: e || null,
        sourceId: t,
        data: {
          html: s.html,
          productId: s.productId,
          newProduct: s.newProduct,
        },
      }));
  }
}
export class CartAddEvent extends Event {
  constructor(e, t, s) {
    (super(CartAddEvent.eventName, { bubbles: !0 }),
      (this.detail = { resource: e, sourceId: t, data: { ...s } }));
  }
  static eventName = ThemeEvents.cartUpdate;
}
export class CartUpdateEvent extends Event {
  constructor(e, t, s) {
    (super(ThemeEvents.cartUpdate, { bubbles: !0 }),
      (this.detail = { resource: e, sourceId: t, data: { ...s } }));
  }
}
export class CartErrorEvent extends Event {
  constructor(e, t, s, r) {
    (super(ThemeEvents.cartError, { bubbles: !0 }),
      (this.detail = {
        sourceId: e,
        data: { message: t, errors: r, description: s },
      }));
  }
}
export class QuantitySelectorUpdateEvent extends Event {
  constructor(e, t) {
    (super(ThemeEvents.quantitySelectorUpdate, { bubbles: !0 }),
      (this.detail = { quantity: e, cartLine: t }));
  }
}
export class DiscountUpdateEvent extends Event {
  constructor(e, t) {
    (super(ThemeEvents.discountUpdate, { bubbles: !0 }),
      (this.detail = { resource: e, sourceId: t }));
  }
}
export class MediaStartedPlayingEvent extends Event {
  constructor(e) {
    (super(ThemeEvents.mediaStartedPlaying, { bubbles: !0 }),
      (this.detail = { resource: e }));
  }
}
export class SlideshowSelectEvent extends Event {
  constructor(e) {
    (super(SlideshowSelectEvent.eventName, { bubbles: !0 }), (this.detail = e));
  }
  detail;
  static eventName = "slideshow:select";
}
export class ZoomMediaSelectedEvent extends Event {
  constructor(e) {
    (super(ThemeEvents.zoomMediaSelected, { bubbles: !0 }),
      (this.detail = { index: e }));
  }
}
export class MegaMenuHoverEvent extends Event {
  constructor() {
    super(ThemeEvents.megaMenuHover, { bubbles: !0 });
  }
}
export class FilterUpdateEvent extends Event {
  constructor(e) {
    (super(ThemeEvents.FilterUpdate, { bubbles: !0 }),
      (this.detail = { queryParams: e }));
  }
  shouldShowClearAll() {
    return (
      [...this.detail.queryParams.entries()].filter(([e]) =>
        e.startsWith("filter."),
      ).length > 0
    );
  }
}
